"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var MediaNodeStore = function MediaNodeStore() {
  var $ = new _rxjs.BehaviorSubject().pipe((0, _operators.scan)(function (state, action) {
    if (action === void 0) {
      action = {};
    }

    switch (action.__id) {
      case 'PUSH_MEDIA_NODE':
        return action.node;

      default:
        return state;
    }
  }, undefined), (0, _operators.skipWhile)(function (val) {
    return !val;
  }), (0, _operators.distinctUntilChanged)(), (0, _operators.shareReplay)(1));
  return {
    $: $,
    destroy: function destroy() {
      $.complete();
    },
    actions: {
      pushMediaNode: function pushMediaNode(node) {
        return $.next({
          __id: 'PUSH_MEDIA_NODE',
          node: node
        });
      }
    }
  };
};

var _default = MediaNodeStore;
exports["default"] = _default;